module.exports = __webpack_public_path__ + "img/hand.96390740.svg";